/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import "./bootstrap";
import Vue from "vue";
import Rollbar from "vue-rollbar";
import router from "./router";
import OnegenLabApp from "./components/OnegenLabApp";
import PeopleGeneticsApp from "./components/PeopleGeneticsApp";
import Onegen01App from "./components/Onegen01App";
import "bootstrap";
import i18n from "./vue-i18n";

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context("./", true, /\.vue$/i);
files.keys().map(key =>
    Vue.component(
        key
            .split("/")
            .pop()
            .split(".")[0],
        files(key).default
    )
);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.config.productionTip = false;
const appRoot = document.getElementById("app");

Vue.use(Rollbar, {
    accessToken: "a5fcd3296b1540b6b78ad67930207825",
    captureUncaught: true,
    captureUnhandledRejections: true,
    enabled: appRoot.dataset.rollbarEnable === "true",
    environment: appRoot.dataset.environment,
    payload: {
        client: {
            javascript: {
                code_version: appRoot.dataset.version,
                source_map_enabled: true,
                guess_uncaught_frames: true
            }
        }
    }
});

Vue.config.errorHandler = (err, vm, info) => {
    Vue.rollbar.error(err);
};

let host = window.location.host.toLowerCase();
host = host.replace(".wip", "");

let App = "";
if (host === "register.onegenlab.com") {
    App = OnegenLabApp;
} else if (host === "registro.people-genetics.com") {
    App = PeopleGeneticsApp;
} else if (host === "register.onegen01.com") {
    App = Onegen01App;
} else {
    App = OnegenLabApp;
}

new Vue({
    i18n,
    router,
    render: h => h(App)
}).$mount(appRoot);
